module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if (inited) { 
__p+='\n<a href="/match-centre/'+
((__t=( round ))==null?'':_.escape(__t))+
'/'+
((__t=( id ))==null?'':_.escape(__t))+
'" class="match-data '+
((__t=( !is_completed ? 'complete' : '' ))==null?'':_.escape(__t))+
'">\n	<div class="opponent home">\n		<div class="squad-name hidden-mobile">\n			<p>\n				'+
((__t=( home_squad_name ))==null?'':_.escape(__t))+
'\n			</p>\n			';
 if (!is_scheduled) { 
__p+='\n			<div class="squad-score '+
((__t=( is_live ? 'live' : '' ))==null?'':_.escape(__t))+
'">'+
((__t=( home_score ))==null?'':_.escape(__t))+
'</div>\n			';
 } 
__p+='\n		</div>\n\n		<figure>\n			<img src="'+
((__t=( image_squads_path + home_squad_id ))==null?'':_.escape(__t))+
'.png" alt="">\n		</figure>\n\n		';
 if (!is_scheduled) { 
__p+='\n		<div class="squad-score hidden-desktop '+
((__t=( is_live ? 'live' : '' ))==null?'':_.escape(__t))+
'">'+
((__t=( home_score ))==null?'':_.escape(__t))+
'</div>\n		';
 } 
__p+='\n\n\n	</div>\n	<div class="match-status">\n		';
 if(is_live){ 
__p+='\n		<div class="live-match-label">\n			<p>LIVE</p>\n			';
 if (time) { 
__p+='\n			<span>'+
((__t=( time ))==null?'':_.escape(__t))+
'</span>\n			';
 } 
__p+='\n			<span class="hidden-mobile">Match Centre</span>\n		</div>\n		';
 } else if(is_completed) { 
__p+='\n		<div class="full-time-match-label">\n			<p>FULL TIME</p>\n			<span class="hidden-mobile">Match Centre</span>\n		</div>\n		';
 } else { 
__p+='\n		<div>'+
((__t=( game_date ))==null?'':_.escape(__t))+
'</div>\n		';
 } 
__p+='\n	</div>\n	<div class="opponent away">\n		';
 if (!is_scheduled) { 
__p+='\n\n		<div class="squad-score hidden-desktop '+
((__t=( is_live ? 'live' : '' ))==null?'':_.escape(__t))+
'">'+
((__t=( away_score ))==null?'':_.escape(__t))+
'</div>\n		';
 } 
__p+='\n\n		<figure>\n			<img src="'+
((__t=( image_squads_path + away_squad_id ))==null?'':_.escape(__t))+
'.png" alt="">\n		</figure>\n\n		<div class="squad-name hidden-mobile">\n			<p>\n				'+
((__t=( away_squad_name ))==null?'':_.escape(__t))+
'\n			</p>\n			';
 if (!is_scheduled) { 
__p+='\n\n			<div class="squad-score '+
((__t=( is_live ? 'live' : '' ))==null?'':_.escape(__t))+
'">'+
((__t=( away_score ))==null?'':_.escape(__t))+
'</div>\n			';
 } 
__p+='\n		</div>\n\n	</div>\n</a>\n';
 } 
__p+='';
}
return __p;
};
